import { render } from "./AdminUserlist.vue?vue&type=template&id=09572928&scoped=true"
import script from "./AdminUserlist.vue?vue&type=script&lang=js"
export * from "./AdminUserlist.vue?vue&type=script&lang=js"

import "./AdminUserlist.vue?vue&type=style&index=0&id=09572928&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09572928"]])

export default __exports__